import React from "react";
import { ReactComponent as EnterFullscreen } from "../../../../../assets/icons/videoPlayer/enterFullscreen.svg";
import { ReactComponent as ExitFullscreen } from "../../../../../assets/icons/videoPlayer/exitFullscreen.svg";

function Fullscreen({ color = "var(--gold)", width = "20px", className = "", onClick = () => {}, isFullscreen }) {
  return isFullscreen ? (
    <ExitFullscreen stroke={color} width={width} height={width} className={className} onClick={onClick} />
  ) : (
    <EnterFullscreen stroke={color} width={width} height={width} className={className} onClick={onClick} />
  );
}

export default Fullscreen;
